module.exports = __webpack_public_path__ + "static/media/keyrune.77551c95.ttf";